export const STORE_NAME_FONT_FAMILIES = {
  "classic-serif": {
    label: "Classic Serif",
    family: 'Georgia, "Times New Roman", serif',
  },
  "playfair-display": {
    label: "Playfair Display",
    family: '"Playfair Display", Georgia, serif',
  },
  "cormorant-garamond": {
    label: "Cormorant Garamond",
    family: '"Cormorant Garamond", Georgia, serif',
  },
  merriweather: { label: "Merriweather", family: "Merriweather, Georgia, serif" },
  lora: { label: "Lora", family: "Lora, Georgia, serif" },
  "libre-baskerville": {
    label: "Libre Baskerville",
    family: '"Libre Baskerville", Georgia, serif',
  },
  cinzel: { label: "Cinzel", family: "Cinzel, Georgia, serif" },
  montserrat: {
    label: "Montserrat",
    family: "Montserrat, Arial, sans-serif",
  },
  raleway: { label: "Raleway", family: "Raleway, Arial, sans-serif" },
  poppins: { label: "Poppins", family: "Poppins, Arial, sans-serif" },
  "open-sans": {
    label: "Open Sans",
    family: '"Open Sans", Arial, sans-serif',
  },
  roboto: { label: "Roboto", family: "Roboto, Arial, sans-serif" },
  nunito: { label: "Nunito", family: "Nunito, Arial, sans-serif" },
  "dm-sans": { label: "DM Sans", family: '"DM Sans", Arial, sans-serif' },
  oswald: { label: "Oswald", family: "Oswald, Arial, sans-serif" },
  inter: { label: "Inter", family: "Inter, Arial, sans-serif" },
};

export const STORE_BRAND_LAYOUTS = {
  logo: [
    { value: "horizontal", label: "Logo beside name" },
    { value: "stacked", label: "Logo above name" },
    { value: "logo-only", label: "Logo only" },
    { value: "name-only", label: "Store name only" },
  ],
  name: [
    { value: "horizontal", label: "Name parts side by side" },
    { value: "stacked", label: "Name parts below each other" },
  ],
  slogan: [
    { value: "below", label: "Below the store name" },
    { value: "beside", label: "Beside the store name" },
  ],
};

export const STORE_BRAND_SEPARATORS = {
  none: "",
  dot: "•",
  diamond: "◆",
  star: "✦",
  circle: "●",
  line: "│",
};

export const BRAND_COLOR_PALETTE = [
  "#111827",
  "#374151",
  "#6b7280",
  "#ffffff",
  "#7f1d1d",
  "#b91c1c",
  "#ea580c",
  "#d97706",
  "#ca8a04",
  "#15803d",
  "#0f766e",
  "#0369a1",
  "#1d4ed8",
  "#4338ca",
  "#7e22ce",
  "#be185d",
  "#8b5e3c",
  "#2c7da0",
  "#61a5c2",
  "#a9d6e5",
];

export const DEFAULT_STORE_BRANDING = {
  storeNameLine1: "",
  storeNameLine2: "",
  storeNameLine1FontFamily: "playfair-display",
  storeNameLine1FontSize: 26,
  storeNameLine1Color: "#1a1d28",
  storeNameLine1Bold: true,
  storeNameLine1Italic: false,
  storeNameLine1Underline: false,
  storeNameLine2FontFamily: "montserrat",
  storeNameLine2FontSize: 20,
  storeNameLine2Color: "#52677b",
  storeNameLine2Bold: true,
  storeNameLine2Italic: false,
  storeNameLine2Underline: false,
  storeNameLayout: "horizontal",
  storeSlogan: "",
  storeSloganFontFamily: "montserrat",
  storeSloganFontSize: 12,
  storeSloganColor: "#687d90",
  storeSloganBold: false,
  storeSloganItalic: false,
  storeSloganUnderline: false,
  storeSloganLayout: "below",
  storeBrandSeparator: "none",
  storeBrandSeparatorColor: "#2c7da0",
  storeLogoSize: 56,
  storeBrandLayout: "horizontal",
  storeNameFontFamily: "playfair-display",
  storeNameFontSize: 24,
  storeNameColor: "#1a1d28",
};
